import { render, staticRenderFns } from "./BulkEditButton.vue?vue&type=template&id=1dd89326"
import script from "./BulkEditButton.vue?vue&type=script&lang=js"
export * from "./BulkEditButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports